module.exports = __webpack_public_path__ + "img/TSD.3fa770f3.png";